import { NgStyle } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { AuthService } from "@app/services/auth.service";
import { TranslateModule } from "@ngx-translate/core";
import { ItCardComponent } from "design-angular-kit";
import { BarrierMapComponent } from "../barriers/barrier-map/barrier-map.component";

@Component({
    selector: "app-home",
    standalone: true,
    imports: [TranslateModule, RouterLink, ItCardComponent, NgStyle, BarrierMapComponent],
    templateUrl: "./home.component.html",
})
export class HomeComponent implements OnInit {
    backgroundImage = `/assets/img/home/${Math.floor(Math.random() * 4) + 1}.jpg`;

    constructor(protected authService: AuthService) {}

    ngOnInit() {}
}
